import { object, string } from 'yup'

// Const
import { Text } from '../../../../constants/TextConstants'

export const EDUCATIONAL_SCHEMA = () =>
  object().shape({
    institute: string().required('Required'),
    grade: string().required('Required'),
    status: string().required('Required').oneOf(['finished', 'not finished'], 'Invalid status'),
    end_date: string()
      .nullable(true)
      .test('is-required-if-finished', Text.Required, function (value) {
        const { status } = this.parent
        return !(status === 'finished' && value === 'In Progress')
      })
      .when('status', {
        is: 'finished',
        then: (schema) => schema.required('Required')
      })
  })

export const CERTIFICATIONS_SCHEMA = () =>
  object().shape({
    certifying_entity: string().required('Required'),
    name: string().required('Required'),
    status: string().required('Required').oneOf(['finished', 'not finished'], 'Invalid status'),
    retriever_date: string()
      .nullable(true)
      .test('is-required-if-finished', Text.Required, function (value) {
        const { status } = this.parent
        return !(status === 'finished' && value === 'In Progress')
      })
      .when('status', {
        is: 'finished',
        then: (schema) => schema.required('Required')
      })
  })
